import { useEffect, useState } from 'react'
import { CameraPermissionState } from '../models'

export const usePermissions = (): string => {
  const [state, setState] = useState(CameraPermissionState.UNKNOWN)

  useEffect(() => {
    try {
      navigator.permissions
        .query({ name: 'camera' })
        .then((result) => {
          setState(result.state as CameraPermissionState)
        })
        .catch(() => {
          setState(CameraPermissionState.UNKNOWN)
        })
    } catch (e) {
      setState(CameraPermissionState.UNKNOWN)
    }
  }, [])

  return state
}
